import { FC } from "react"
import { Modal } from "@components/modal"

export interface InstallmentModalProps {
  show: boolean
  onHide: any
}

export const InstallmentSuccessModal: FC<InstallmentModalProps> = ({ show, onHide }) => {
  return (
    <>
      <Modal show={show} onClose={onHide}>
        <div className="text-center max-w-xl p-8">
          <div className="font-bold text-2xl">
            Terima Kasih Telah Mengisi Form Pengajuan Cicilan!{" "}
          </div>
          <div className="text-grey-97 text-base mt-2">
            Datamu sudah kami terima. Tim harisenin.com akan menghubungimu segera untuk informasi
            lebih lanjutnya{" "}
          </div>
        </div>
      </Modal>
    </>
  )
}
